import { useEffect, useRef } from 'react';
import { useMap } from './mapContext';

/**
 * Kind of pointer ('mouse', 'touch', 'pen') that last pressed on the map, to tell a mouse click from
 * a tap: MapLibre reports both as 'click' and touch screens fire emulated mouse events too.
 */
export function usePointerType() {
  const map = useMap();
  const type = useRef('mouse');

  useEffect(() => {
    if (!map) return;
    const el = map.getCanvasContainer();
    const listener = (e: PointerEvent) => void (type.current = e.pointerType);
    el.addEventListener('pointerdown', listener, true);
    return () => el.removeEventListener('pointerdown', listener, true);
  }, [map]);

  return type;
}
